export const FeeFormulaConfirmModalContract = {
    $schema: 'http://json-schema.org/draft-07/schema#',
    $id: 'http://example.com/product.schema.json',
    $title: 'Save changes modal',
    $description: 'JSON Schema Contract for FeevFormula Confirm Modal',
    $type: 'object',
    properties: {}
};
